import WidgetComponent, { IWidgetLayout } from "../../../components/widgets-layout/widget-component/widget-component";
import { IWidgetModal, Widget } from "../../../components/widgets-layout/widget-utils";
import { IWidgetLayoutConfig } from "../../../components/widgets-layout/widgets-layout";

interface IScreenConfigurationConfig {
  layout: IWidgetLayout;
  selectedEntity: string;

  handleDataChange(data: IScreenConfigurationData): void;
}

export interface IScreenConfigurationData {
  layout: IWidgetLayoutConfig[];
  layoutItems: Widget[];
}

const ScreenConfiguration = ({layout, selectedEntity, handleDataChange}: IScreenConfigurationConfig) => {
  const handleLayoutChange = (layout: IWidgetLayout) => {
    handleDataChange(layout);
  };

  const widgets: IWidgetModal[] = [{
    type: "text"
  },
  {
    type: "reference",
    datamodelId: selectedEntity,
    datamodelType: "entity",
  },
  {
    type: "datamodelField",
    datamodelId: selectedEntity,
    datamodelType: "entity",
  }];

  return <div className="screenConfiguration">
    <WidgetComponent 
      handleLayoutChange={handleLayoutChange}
      widgets={widgets}
      layout={layout} />
  </div>;
};

export default ScreenConfiguration;